import { create } from 'zustand';

import { Departments } from '@/types';
import storage from '@/utils/storage';

type DepartmentStore = {
  selected: Departments;
  select: (department: Departments) => void;
};

export const useDepartmentStore = create<DepartmentStore>((set) => {
  const storedDepartment = storage.getDepartment();
  const department = storedDepartment
    ? Departments[storedDepartment as keyof typeof Departments]
    : Departments.en;

  return {
    selected: department,
    select: (department) => {
      storage.setDepartment(department);
      set({ selected: department });
    },
  };
});
